import Div from '@ui/layout/Div'
import Form from '@ui/elements/Form'
import sterilizationCompanyCallFormFields, { sterilizationCompanyCallSaveUrl } from "@form/sterilizationCompanyCallFormFields"
import { useDispatch, useSelector } from "react-redux"
import useStoreUpdate from "@hook/useStoreUpdate"
import useToggle from "@hook/useToggle"
import useMainData from '@hook/useMainData'
import useFormData from "@hook/useFormData"
import { updateSterilizationCompanyCallFormObject } from "@store/slice/sterilizationSlice"
import { post } from '@util/xhrAPI'
import { updateNotification, updateValidationPage } from '@store/slice/mainSlice'
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import { func } from 'prop-types'
import { useNavigate } from 'react-router'
import { ROLE_PUBLIC } from "@router/Routes"

const CompanySterilizationCallForm = ({ nextStep }) => {
  const { sterilizationCompanyCallFormObject, errors } = useSelector(state => state.sterilization)
  const { data, mission } = useSelector(state => state.main)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [updateFormObject, updateFormObjectProp] = useStoreUpdate(dispatch, updateSterilizationCompanyCallFormObject, sterilizationCompanyCallFormObject)
  const [isLoading, toggleLoading] = useToggle(false)
  const [userCoordinates, setUserCoordinates] = useState(null)
  const [t] = useTranslation('sterilization')
  const renderFormData = useFormData()
  const loadData = useMainData()

  const generateFormStep = step => {
    return sterilizationCompanyCallFormFields(
      step,
      sterilizationCompanyCallFormObject,
      updateFormObject,
      updateFormObjectProp,
      errors,
      saveForm,
      isLoading,
      t,
      data,
      mission
    )
  }

  const fetchInitialData = () => {
    const dataObject = {
      cities: 'cities',
      districts: 'districts'
    }
    loadData(dataObject)
  }

  const saveForm = () => {
    toggleLoading()
    post(sterilizationCompanyCallSaveUrl, renderFormData(sterilizationCompanyCallFormObject, ['userCoordinates']), response => {
      const { code, sterilizationCall, validationPage, errors } = response
      if (200 === code) {
        dispatch(updateNotification({ type: 'is-success', message: t('messages.call_created_successfuly') }))
        dispatch(updateSterilizationCompanyCallFormObject(sterilizationCall))
        window.sessionStorage.setItem('lastCompanyCall', sterilizationCall.id)
        if (mission.isCompanyBilled) {
          nextStep('buildings')
        } else {
          dispatch(updateValidationPage(validationPage))
          navigate(ROLE_PUBLIC['publicValidation'])
        }
      } else {
        dispatch(updateNotification({ type: 'is-danger', message: t(`messages.${errors.length ? errors[0] : 'errors_encountered'}`) }))
      }

      toggleLoading()
    })
  }

  useEffect(() => {
    updateFormObjectProp('mission', mission.id)
    fetchInitialData()
  }, [])

  useEffect(() => {
    if (window.innerWidth <= 768) { //get user location if on mobile
      navigator.geolocation.getCurrentPosition(function (position) {
        setUserCoordinates({ lat: position.coords.latitude, lng: position.coords.longitude })
      })
    }
  }, [])

  useEffect(() => {
    if (userCoordinates) {
      updateFormObjectProp('userCoordinates', userCoordinates)
    }
  }, [userCoordinates])

  return (
    <Form cssClass='citizen-sterilization-call'>
      <Div cssClass='columns is-multiline'>
        {generateFormStep('call')}
      </Div>

      <Div cssClass='columns is-multiline'>
        <Div cssClass='column is-6 is-multiline'>
          {generateFormStep('establishmentResponsible')}
        </Div>
        <Div cssClass='column is-6 is-multiline'>
          {generateFormStep('callResponsible')}
        </Div>
      </Div>

      <Div cssClass='columns is-multiline'>
        {generateFormStep('callLocation')}
      </Div>
      {'company' === sterilizationCompanyCallFormObject.callType && <>
        <Div cssClass='columns is-multiline'>
          {generateFormStep('company')}
        </Div>
      </>}

      <Div cssClass='columns is-multiline'>
        {generateFormStep('callChecks')}
      </Div>
    </Form>
  )
}

CompanySterilizationCallForm.propTypes = {
  nextStep: func
}

export default CompanySterilizationCallForm
